import React, { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import './limaLogin.css';

const API_URL = '/.netlify/functions';

const AutoLogin: React.FC = () => {
  const [searchParams] = useSearchParams();
  const token = searchParams.get('token');
  const navigate = useNavigate();
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    if (!token) {
      setError('No login token provided');
      return;
    }

    const exchangeToken = async () => {
      try {
        const response = await fetch(`${API_URL}/cross-login`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ token })
        });

        const data = await response.json();

        if (!response.ok || !data.success) {
          setError(data.message || 'Login failed');
          return;
        }

        if (data.user.role !== 'client') {
          setError('Cross-login is only available for client accounts');
          return;
        }

        localStorage.setItem('lima_auth_token', data.token);
        localStorage.setItem('lima_user', JSON.stringify({
          _id: data.user._id || '',
          uname: data.user.email,
          role: 'client',
          active: true,
          clients: data.user.clients || [],
          clientName: data.user.clientName || null
        }));

        if (data.crossLogin) {
          sessionStorage.setItem('lima_cross_login', 'true');
        }

        // The client portal is its own page, so this is a real page load.
        // "to" lets the quote site send a client straight to one page of their portal
        // (My Quotes). Only pages inside the client portal are accepted.
        const to = searchParams.get('to') || '';
        window.location.replace(/^\/user\/[a-z0-9\/_-]*$/i.test(to) ? to : '/user/');
      } catch {
        setError('Connection failed. Please try again.');
      }
    };

    exchangeToken();
  }, [token, navigate]);

  return (
    <div className="lima-login">
      <div className="ll-card">
        <a href="https://limaautomotive.com/" aria-label="LIMA Automotive home" style={{ display: 'block', width: 'fit-content', margin: '0 auto' }}><img className="ll-logo" src="/LIMA_LOGO_LOGIN.png" alt="LIMA Automotive" /></a>
        <span className="ll-pill">Shipment Portal</span>
        {error ? (
          <>
            <h1 className="ll-title">Could not sign you in</h1>
            <div className="ll-msg" role="alert">
              <div className="ll-alert err">{error}</div>
            </div>
            <button type="button" className="ll-btn" style={{ marginTop: 16 }} onClick={() => navigate('/login')}>
              Go to login
            </button>
          </>
        ) : (
          <>
            <h1 className="ll-title">Signing you in…</h1>
            <p className="ll-sub">One moment please</p>
            <div className="ll-spin" style={{ marginTop: 20 }} aria-label="Loading" />
          </>
        )}
      </div>
      <div className="ll-foot">LIMA Automotive Industries<br /><span style={{ whiteSpace: 'nowrap' }}>Toll Free +1 877 298-0911</span></div>
    </div>
  );
};

export default AutoLogin;
